import {createContext} from 'react';

const listaCarrerasContext = createContext();

export default listaCarrerasContext;